module.exports = __webpack_public_path__ + "img/car_12.2049e890.jpg";